import { RootState } from "@/src/app/store";
import { createSlice } from "@reduxjs/toolkit";
import { createCase } from "./Thunks";

type CaseCreationStatus = 'idle' | 'creating' | 'created' | 'failed'
interface CaseCreationState {
    status: CaseCreationStatus
    caseId?: string;
    uin?: string;
}

const initialState: CaseCreationState = {
    status: 'idle',
}

const caseCreationSlice = createSlice({
    name: 'caseCreation',
    initialState,
    reducers: {
        clearCaseCreationStatus() {
            return initialState;
        }
    },
    extraReducers: builder => {
        builder.addCase(createCase.pending, (state) => {
            state.status = 'creating'
        })
        builder.addCase(createCase.fulfilled, (state, action) => {
            state.caseId = action.payload.case_id
            state.uin = action.payload.uin
            state.status = 'created'
        })
        builder.addCase(createCase.rejected, (state) => {
            state.status = 'failed'
        })
    }
})

export const getCaseCreationStatus = (state: RootState) => (state.caseCreation.status)
export const getCaseCreationState = (state: RootState) => (state.caseCreation)

export const {clearCaseCreationStatus} = caseCreationSlice.actions

export const caseCreationReducer = caseCreationSlice.reducer;